import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { useMemo } from "react";

const TIME_TYPE_BASE = "/Time/TimeTypes";

const getTimeTypesList = () => API.get(TIME_TYPE_BASE);

const addTimeTypeAPI = (data) =>
  API.post(TIME_TYPE_BASE, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateTimeTypeAPI = (id, data) =>
  API.patch(`${TIME_TYPE_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "timeTypes",
  apiFetchFn: getTimeTypesList,
  apiAddFn: addTimeTypeAPI,
  apiUpdateFn: updateTimeTypeAPI,
});

const timeTypeReducer = baseService.reducer;
const getTimeType = baseService.getData;
const addTimeType = baseService.addData;
const updateTimeType = baseService.updateData;
const useTimeType = baseService.useData;

const useActiveTimeTypes = () => {
  const { data, loading } = useTimeType();
  const activeTimeTypes = useMemo(
    () => data.filter((type) => type.active),
    [data]
  );
  return { data: activeTimeTypes, loading };
};

export {
  timeTypeReducer,
  getTimeType,
  addTimeType,
  updateTimeType,
  useTimeType,
  useActiveTimeTypes,
};
